/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
// Utils
// import { notifyPaymentRequired } from 'common/utils/customerValidation'

// Styled Elements
import {
  MenuDetailedWrapper,
  Header,
  XStack,
  YStack,
  Divider,
  MenuNavLink,
} from '../common.elements'

// Map Redux Props
function ReportsSidebar() {
  return (
    <MenuDetailedWrapper>
      <YStack style={{ gap: '8px' }}>

        <YStack style={{ gap: '8px', padding: '0 20px' }}>
          <XStack style={{ alignItems: 'center', gap: '12px' }}>
            <Header>Reports</Header>
          </XStack>
        </YStack>
        <XStack style={{ padding: '8px 20px' }}>
          <Divider />
        </XStack>

        <YStack style={{ padding: '0 8px' }}>
          <MenuNavLink to="/reports">Blockchain Analytics</MenuNavLink>
          <MenuNavLink to="/reports/travelrule">Travel Rule</MenuNavLink>
        </YStack>
      </YStack>

    </MenuDetailedWrapper>
  )
}

export default ReportsSidebar
